import styled from "styled-components";

export const BorderLineContainer = styled.div`
  width: 100%;
  height: 5px;
  background-color: #70AD47;
`